export default __webpack_public_path__ + "static/media/practitioner.04fa9609.png";